import React from "react";

const EscrowButton = () => {
  return (
    <form action="https://www.escrow.com/checkout" method="post">
      <input type="hidden" name="type" value="domain_name" />
      <input
        type="hidden"
        name="non_initiator_email"
        value="amanmohsin250@gmail.com"
      />
      <input type="hidden" name="non_initiator_id" value="2851007" />
      <input type="hidden" name="non_initiator_role" value="seller" />
      <input type="hidden" name="title" value="test transaction" />
      <input type="hidden" name="currency" value="USD" />
      <input type="hidden" name="domain" value="https://ammanat.netlify.app/" />
      <input type="hidden" name="price" value="100" />
      <input type="hidden" name="concierge" value="false" />
      <input type="hidden" name="with_content" value="false" />
      <input type="hidden" name="inspection_period" value="1" />
      <input type="hidden" name="fee_payer" value="buyer" />
      <input
        type="hidden"
        name="return_url"
        value="https://ammanat.netlify.app/payment-method"
      />
      <input type="hidden" name="button_types" value="buy_now" />
      <input type="hidden" name="auto_accept" value="" />
      <input type="hidden" name="auto_reject" value="" />
      <input type="hidden" name="item_key" value="undefined" />
      <button class="EscrowButtonSecondary" type="submit">
        Confirm Booking
      </button>
      {/* <img
        src="https://t.escrow.com/1px.gif?name=bin&price=0&title=test%20transaction&user_id=2851007"
        style="display: none;"
      /> */}
    </form>
  );
};

export default EscrowButton;
